import fetch from "cross-fetch";
import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { env } from "../../common/__config__/env";

const link = createHttpLink({
  uri: env.RT_CLUSTER_GRAPH_URL,
  fetch: fetch,
});

const cache = new InMemoryCache();
export const rtcluster = new ApolloClient({
  name: "privatmegleren_objektsider_client",
  link: link,
  cache: cache,
});
